import React, { useState, useEffect, useRef } from 'react';
import 'devextreme/data/odata/store';
import DataGrid, {
    Editing,
    Column,
    Paging,
    SearchPanel,
    RequiredRule,
} from 'devextreme-react/data-grid';
import SelectBox from 'devextreme-react/select-box';
import EntityService from "../../api/entity.service";
import Toast from 'components/Toast';
import DOMPurify from 'dompurify';
import { Popup } from 'devextreme-react/popup';
import SlidingDrawer from 'components/sliding-drawer/SlidingDrawer';
import './tenantRules.css'
import { useHistory } from "react-router-dom";
import {LoadPanel as LoadingPanel} from 'devextreme-react/load-panel';
import { Tooltip } from 'devextreme-react';

export default function App(props) {
    const history = useHistory();
    const tenantId = props.match.params.tenantId
    const [data, setData] = useState([])
    const dropDataGridRef = useRef();
    const [loading, setLoading] = useState(false);
    const [loadingText, setloadingText] = useState('Loading...');
    const [popupVisible2, setPopupVisible2] = useState(false)
    const [popupVisible, setPopupVisible] = useState(false)
    const [ruleLabel, setRuleLabel] = useState()
    const [ruleType, setRuleType] = useState(null)
    const [ruleId, setRuleId] = useState(null)
    const [pageName, setPageName] = useState("")
    const [deleteMsg, setDeleteMsg] = useState("")
    const [toastConfig, setToastConfig] = React.useState({
        isVisible: false,
        type: 'info',
        message: '',
        displayTime: 5000
    });

    function getData() {
        EntityService.getTenantEntityRulesAvailable(tenantId).then((value) => {
            let result
            if (value?.data?.data?.rules?.length > 0){
                setData(value.data.data.rules)
                result = value?.data?.data?.allRules.filter(o1 => !value?.data?.data?.rules.some(o2 => o1.id === o2.id));
                setRuleLabel(result)
            } else {
                setloadingText("No Data")
                setRuleLabel(value?.data?.data?.allRules)
            }
            setPageName(value?.data?.data?.tenantName)
        })
    }

    useEffect(() => {
        getData()
    }, []);

    function addOnClick() {
        setPopupVisible2(true)
    }

    function onHiding() {
        setRuleType(null)
        setPopupVisible(false)
        setPopupVisible2(false)
    }

    function onSlidingDrawerClose() {
        setRuleType(null)
        setPopupVisible2(false)
    }

    function onRuleChanged(e) {
        setRuleType(e.value)
    }

    function onRowRemoved(e) {
        setLoading(true)
        EntityService.deleteTenantRule(tenantId, e.data.id).then((res) => {
            if(res.data.message === "Rule has been removed from tenant"){
                setToastConfig({
                    ...toastConfig,
                    isVisible: true,
                    type: res.status===200 ? 'success' : 'error',
                    status: res?.data?.status ? res.data.status : res?.status,
                    message: res?.data?.message ? res.data.message : res?.message,
                  });
            } else {
                if (res.data.message){
                    setDeleteMsg(res.data.message)
                    setRuleId(e.data.id)
                }
                setPopupVisible(true)
            }
        }).finally(() => {
            getData();
            setLoading(false)
          });
        
      }

    function addRuleToTenant(e) {
        setLoading(true)
        EntityService.addRuleToTenant(tenantId, ruleType).then(async (value) => {
            setPopupVisible2(false)
            setPopupVisible(false)
            setRuleType(null)
            await setToastConfig({
                ...toastConfig,
                isVisible: true,
                type: value.status===200 ? 'success' : 'error',
                status: value?.data?.status ? value.data.status : value?.status,
                message: value?.data?.message ? value.data.message : value?.message,
            });
        }).finally(() => {
            getData();
            setLoading(false)
          });
    }

    function deleteRuleFromTenant(e){
        EntityService.deleteTenantRule(tenantId, ruleId, true).then((res) => {
            setPopupVisible(false)
            setToastConfig({
                ...toastConfig,
                isVisible: true,
                type: res.status===200 ? 'success' : 'error',
                status: res?.data?.status ? res.data.status : res?.status,
                message: res?.data?.message ? res.data.message : res?.message,
              });
            getData()
            setTimeout(() => {
                getData()
            }, 4000);
        })
    }

    function closeTenant(){
        history.push("/config/tenants");
    }

    function backClickEntities(){
        setPopupVisible2(false)
      }

    return (
        <>
        <SlidingDrawer
            isOpen={popupVisible2}
            onClose={onSlidingDrawerClose}
            title="Add Rule"
            showFooter={false}
        >
            <div className='entityRuleMap-select'>
                <span style={{fontSize:"12px", color:"rgba(117,117,117,.87)", paddingRight:"21%", paddingTop:"15px"}}>Rule&nbsp;Name</span>
                <SelectBox
                    items={ruleLabel}
                    value={ruleType}
                    onValueChanged={onRuleChanged}
                    placeholder="Select a Rule"
                    valueExpr="id"
                    displayExpr="name"
                    dropDownOptions={{ container: '.slide-pane' }}
                />
            </div>
            <div className="entityGroup-setEntities" onClick={addRuleToTenant} style={{ marginRight:"2%" }}>
                SAVE
            </div>
            <div className="entityGroup-setEntitiesCancel" onClick={backClickEntities}>
                DISCARD
            </div>
        </SlidingDrawer>

        <Popup
            visible={popupVisible}
            onHiding={onHiding}
            dragEnabled={false}
            width={500}
            height={200}
            showTitle={false}
            container=".dx-viewport"
        >
            <p>
            {deleteMsg}
            </p>
                
        <div className="addRule" onClick={onHiding}>
            KEEP
        </div>
        <div className="delRule" onClick={deleteRuleFromTenant}>
            DELETE
        </div>
        </Popup>
        <div className='headerHeadingPage'>
            <div className='pageFullWidthEvents'>
            <div className='editentities_col'>
            <div style={{ fontSize: "large", display: "inline-block" }}>Available rules for: {pageName}</div>
            <i className="entity-group-add dx-icon-close" onClick={closeTenant}></i>
            <i onClick={addOnClick} id='ruleBtn' className="entity-group-add dx-icon-add add" style={{ "fontSize": "24px", cursor: 'pointer' }} >
                <Tooltip
                    target="#ruleBtn"
                    showEvent="mouseenter"
                    hideEvent="mouseleave"
                    position="bottom"
                    >
                    <div className="custom-tooltip">Add a Rule</div>
                </Tooltip>
            </i>
        </div>
        <DataGrid
            id="tenant-rule-grid"
            ref={dropDataGridRef}
            showColumnLines={false}
            showRowLines={true}
            height={'calc(100vh - 51px)'}
            noDataText={loadingText}
            onRowRemoved={onRowRemoved}
            allowColumnResizing={true}
            //onRowUpdating={onRowUpdating}
            onColumnsChanging={function (e) {
            if(e.component?.getDataSource()?._totalCount <= 0 && data.length > 0){
              setloadingText('No Data');
            }
        }}
        dataSource={data}>
        <Paging enabled={false} />
        <Editing
          allowUpdating={false}
          allowDeleting={true}
          allowAdding={false}
          use-icons={true}
          mode="popup"
          texts={{
            // addRow: 'Add a Rule',
            confirmDeleteMessage:"Are you sure you want to delete this Rule?"
        }}
        ></Editing>
        <SearchPanel visible="true" width="240" placeholder="Search..." />
        <Column
          dataField={DOMPurify.sanitize('name')}
          caption={"Rule Name"}
          hidingPriority={8}
        >
          <RequiredRule />
        </Column>
      </DataGrid>
      <LoadingPanel
        shadingColor="rgba(0,0,0,0.4)"
        visible={loading}
        showIndicator={true}
        showPane={true}
        shading={true}
        hideOnOutsideClick={false}
      />
            </div>
        </div>
        
      <Toast
        setParentToastConfig={setToastConfig}
        toastBody={toastConfig}
      />
        </>
    );
}
